import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  updateSyllabusAction,
  createSyllabusAction,
} from "../../../../../redux/actions/syllabusActions";
import { SEARCH_VALUES_ACTION_TYPES } from "../../../../../redux/actions-type";
import LoadingBtn from "../../../../Loading/components/LoadingBtn/LoadingBtn";

const SubmitBtn = ({ formik, modalData, funcType, pdfFile }) => {
  const dispatch = useDispatch();
  const { syllabusModalLoading: modalLoading } = useSelector(
    (state) => state.syllabusModal
  );
  const [isDisabled, setIsDisabled] = useState(() => {
    if (funcType === "update") {
      return false;
    } else {
      return true;
    }
  });

  const dataCreate = () => {
    const fd = new FormData();

    if (modalData?.course?._id) fd.append("course", modalData.course._id);

    if (pdfFile) {
      fd.append("pdf", pdfFile);
    }

    if (modalData?._id) {
      dispatch(
        updateSyllabusAction(modalData._id, { course: modalData.course._id })
      );
    } else {
      if (!modalData?.course?._id) {
        alert("Kurs seçilməyib.");
        return;
      }
      dispatch(createSyllabusAction(fd));
    }
  };

  useEffect(() => {
    setIsDisabled(() => {
      if (funcType === "update") {
        if (Object.keys(formik.errors).length === 0) {
          return false;
        } else {
          return true;
        }
      } else {
        if (formik.isValid) {
          return false;
        } else {
          return true;
        }
      }
    });
  }, [formik.errors]);

  return (
    <div>
      <div className="create-update-modal-btn">
        <button disabled={isDisabled || modalLoading} onClick={dataCreate}>
          {modalLoading ? (
            <LoadingBtn />
          ) : funcType === "update" ? (
            "Yenilə"
          ) : (
            "Yarat"
          )}
        </button>
      </div>
    </div>
  );
};

export default SubmitBtn;
